import * as maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { Protocol } from 'pmtiles';

// نقشه‌ی خیابان‌های تهران — همه‌چیز از سرور خودمان (/geo) خوانده می‌شود، بدون اینترنت به سرویس‌های خارجی.
// کاربر و پرسنل از یک نقشه (و یک فایل کاشی) استفاده می‌کنند تا محدوده‌ها دقیقاً منطبق باشند.
// پیش‌نیازها در سرور: /geo/tehran-streets.pmtiles، /geo/fonts/Vazirmatn-Regular/{range}.pbf، /geo/rtl/mapbox-gl-rtl-text.min.js

const FONT = 'Vazirmatn-Regular';

let ready = false;
function setupOnce() {
  if (ready) return;
  ready = true;
  // فایلِ worker خودِ MapLibre را از سرور خودمان می‌خوانیم (نه از باندلِ وب‌پک)
  maplibregl.setWorkerUrl(`${window.location.origin}/geo/maplibre-gl-worker.mjs`);
  const protocol = new Protocol();
  maplibregl.addProtocol('pmtiles', protocol.tile);
  // شکل‌دهیِ حروفِ فارسی در MapLibre v6 بدونِ افزونه انجام می‌شود، پس نیازی به setRTLTextPlugin نیست
}

// عرضِ خیابان‌ها با زوم (ساده و خوانا)
const ROAD_WIDTH = ['interpolate', ['linear'], ['zoom'], 10, 0.6, 13, 2.5, 15, 6];

export function streetStyle() {
  const origin = window.location.origin;
  const src = 'streets';
  return {
    version: 8,
    glyphs: `${origin}/geo/fonts/{fontstack}/{range}.pbf`,
    sources: {
      [src]: {
        type: 'vector',
        url: `pmtiles://${origin}/geo/tehran-streets.pmtiles`,
        minzoom: 0,
        maxzoom: 15,
      },
    },
    layers: [
      { id: 'background', type: 'background', paint: { 'background-color': '#f4f1ea' } },
      { id: 'landuse', type: 'fill', source: src, 'source-layer': 'landuse', paint: { 'fill-color': '#e9efdc' } },
      { id: 'water', type: 'fill', source: src, 'source-layer': 'water', paint: { 'fill-color': '#bcd9ea' } },
      {
        id: 'buildings',
        type: 'fill',
        source: src,
        'source-layer': 'buildings',
        minzoom: 14,
        paint: { 'fill-color': '#dcd6cc' },
      },
      {
        id: 'roads-casing',
        type: 'line',
        source: src,
        'source-layer': 'roads',
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: { 'line-color': '#d2ccbf', 'line-width': ['interpolate', ['linear'], ['zoom'], 10, 0.8, 13, 3.2, 15, 7.5] },
      },
      {
        id: 'roads',
        type: 'line',
        source: src,
        'source-layer': 'roads',
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: { 'line-color': '#ffffff', 'line-width': ROAD_WIDTH },
      },
      {
        id: 'road-labels',
        type: 'symbol',
        source: src,
        'source-layer': 'roads',
        minzoom: 14,
        filter: ['has', 'name'],
        layout: {
          'symbol-placement': 'line',
          'text-field': ['get', 'name'],
          'text-font': [FONT],
          'text-size': 12,
          'text-max-angle': 30,
        },
        paint: { 'text-color': '#333333', 'text-halo-color': '#ffffff', 'text-halo-width': 1.5 },
      },
      {
        id: 'place-labels',
        type: 'symbol',
        source: src,
        'source-layer': 'places',
        filter: ['has', 'name'],
        layout: {
          'text-field': ['get', 'name'],
          'text-font': [FONT],
          'text-size': ['interpolate', ['linear'], ['zoom'], 8, 11, 14, 15],
        },
        paint: { 'text-color': '#222222', 'text-halo-color': '#ffffff', 'text-halo-width': 1.5 },
      },
    ],
  };
}

// center: [lng, lat]
export function createStreetMap(container, { center = [51.389, 35.6892], zoom = 11, nav = true } = {}) {
  setupOnce();
  const map = new maplibregl.Map({
    container,
    style: streetStyle(),
    center,
    zoom,
    minZoom: 8,
    maxZoom: 18,
    attributionControl: { compact: true },
  });
  if (nav) map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
  return map;
}
